export enum FlashbagType {
    Info = 'info',
    Success = 'success',
    Warning = 'warning',
    Danger = 'danger'
}

export class Flashbag {
    title: string;
    message: string;
    type: FlashbagType; 
    length: number;

    constructor(title: string, message: string, type: FlashbagType, length: number) {
        this.title = title;
        this.message = message;
        this.type = type;
        this.length = length;
    }
}